import { useTransition as k, TransitionPresets as O, toReactive as A, isClient as F, useWindowScroll as H } from "@vueuse/core";
import { capitalize as E } from "lodash-es";
import { inject as C, computed as g, ref as y, unref as a, watch as v, onBeforeUnmount as K, provide as w, onMounted as M, nextTick as b } from "vue";
import { nanoid as $ } from "nanoid";
const T = Symbol("jk/collapseController"), q = () => C(T), S = Symbol("jk/collapseContext"), R = () => C(S);
function U(c, e) {
  const d = (e == null ? void 0 : e.id) ?? $(), n = g(() => (e == null ? void 0 : e.dimension) ?? "height"), t = y(e != null && e.initiallyClosed ? 0 : 100), r = y(!(e != null && e.initiallyClosed)), u = k(t, {
    ...e,
    duration: (e == null ? void 0 : e.duration) ?? 300,
    transition: (e == null ? void 0 : e.transition) ?? O.easeInOutCubic,
    onFinished: () => {
      window.requestAnimationFrame(() => {
        var f;
        const l = a(c);
        !l || a(u) !== a(t) || (l.style.overflow = null, l.style[a(n)] = null, a(t) === 0 && (l.style.display = "none"), (f = e == null ? void 0 : e.onFinished) == null || f.call(e));
      });
    }
  }), s = () => {
    var l;
    return ((l = a(c)) == null ? void 0 : l[`scroll${E(a(n))}`]) ?? 0;
  }, h = y(s()), i = g(
    () => a(u) / 100 * a(h)
  ), m = async () => {
    const l = a(c);
    l && (a(t) > 0 && (h.value = s()), l.style.overflow = "hidden", l.style.display = "", a(t) === 0 ? (l.style[a(n)] = "0", await b(), h.value = s()) : (l.style[a(n)] = "", await b()));
  }, x = async () => {
    await m(), t.value = 0;
  }, j = async () => {
    await m(), t.value = 100;
  };
  if (v(i, (l) => {
    const f = a(c);
    f && (f.style[a(n)] = `${l}px`);
  }), v(r, (l, f) => {
    l !== f && (l ? j() : x());
  }), e != null && e.controlled) {
    const l = q(), f = l == null ? void 0 : l.control(d, r);
    K(() => {
      f == null || f();
    });
  }
  return e != null && e.provide && w(S, { id: d, toggle: r, ref: c }), M(() => {
    if (!r.value) {
      const l = a(c);
      if (!l || !(l instanceof Element))
        return;
      l.style.display = "none";
    }
  }), r;
}
function W(c) {
  const e = A((c == null ? void 0 : c.value) ?? {}), d = () => {
    const t = Object.entries(e).filter(([r, u]) => u);
    if (t.length > 1)
      for (const [r] of t.slice(0, -1))
        e[r] = !1;
  };
  v(
    () => ({ ...e }),
    (t, r) => {
      if (r) {
        const u = Object.keys(t), s = u.filter(
          (i) => t[i] === r[i]
        ), h = u.filter(
          (i) => t[i] !== r[i]
        );
        if (!s.length || !t[h[0]])
          return;
        for (const i of s)
          e[i] = !1;
        d();
      }
    },
    { immediate: !0 }
  );
  const n = (t, r) => (e[t] = r, d(), () => {
    delete e[t];
  });
  return c != null && c.provide && w(T, { control: n }), n;
}
function _(c) {
  const e = c.scrollThreshold ?? 50, d = c.topThreshold ?? 0, n = y(!0), t = y(!1);
  if (!F)
    return {
      beginning: n,
      downward: t,
      y: y(0)
    };
  const { y: r } = H();
  t.value = r.value > 0;
  const u = y(0);
  return v([r], ([s]) => {
    if (s === 0) {
      n.value = !0, t.value = !1;
      return;
    }
    n.value = s < d, !(Math.abs(s - u.value) < e) && (t.value = s > u.value, u.value = s);
  }), {
    beginning: n,
    downward: t,
    y: r
  };
}
export {
  W as useAccordion,
  U as useCollapse,
  R as useCollapseContext,
  q as useCollapseController,
  _ as useScrollState
};
